// @TODO use this in the bitwise arithmetic validation builder
// @TODO check v8 on this
// eslint-disable-next-line
module.exports = (x, y) => x == y
